<template>
  <swiper
    ref="swiper"
    :modules="modules"
    v-show="!isLoading && token && user.followingNo === 0"
    class="pt-6 my-2"
    dir="rtl"
    :centeredSlides="true"
    :slidesPerView="'auto'"
    :spaceBetween="10"
    @swiper="slideChange"
    @slideChange="slideChange"
  >
    <swiper-slide
      v-slot="{ isActive }"
      v-for="(suggest, index) in suggestions.slice(0, 20)"
      :key="index"
    >
      <v-card
        width="250"
        height="300"
        elevation="3"
        class="rounded-lg"
        @click="slideTo(index)"
        :class="[isActive ? 'pop-active' : 'pop']"
      >
        <div class="center text-center">
          <picture>
            <source type="image/webp" :srcset="suggest.image" />
            <v-avatar width="60" height="60" class="">
              <v-img class="mx-auto" :src="suggest.image"></v-img>
            </v-avatar>
          </picture>
          <v-card-title>{{ suggest.name }}</v-card-title>
          <p>{{ suggest.groups_name[0] }}</p>
          <v-card-subtitle>{{ suggest.basedOn }}</v-card-subtitle>
          <br />
          <v-btn
            @click="
              [
                suggest.isFollow == false
                  ? (suggest.isFollow = true)
                  : (suggest.isFollow = false),
              ]
            "
            small
            width="95px"
            :color="suggest.isFollow == true ? 'primary' : 'success'"
            rounded
            >دنبال کردن</v-btn
          >
        </div>
      </v-card>
    </swiper-slide>
  </swiper>
</template>

<script>
// import { Swiper, SwiperSlide } from "swiper/vue";
import { Swiper, SwiperSlide } from "swiper-vue2";
import { Mousewheel, Navigation } from "swiper";
import "swiper/css";
export default {
  data() {
    return {
      token: null,
      user: [],
      form: {
        // mobiles: [],
      },
      modules: Mousewheel,
      isLoading: true,
      suggestions: [],
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    Mousewheel,
    Navigation,
  },
  methods: {
    async suggest() {
      var self = this;
      this.isLoading = true;
      let response = await self.axios.post(
        "https://namya.ir/api/v1/home/suggestions",
        this.form,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      self.suggestions = response.data.data;
      this.isLoading = false;
    },
    Swiper(swiper) {
      console.log(swiper);
    },
    slideChange(swiper) {
      swiper.device.android = true;
      swiper.device.ios = true;
    },
    slideTo(index) {
      // this.swiper = swiper;
      this.$refs.swiper.swiperRef.slideTo(index);
    },
    async GetUser() {
      var self = this;
      let response = await self.axios.get("https://namya.ir/api/v1/users", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.token}`,
          "Access-Control-Allow-Origin": "*",
        },
      });
      self.user = response.data.data;
    },
  },
  mounted() {
    new Swiper(this.$refs.swiper, {
      // Optional parameters
      loop: true,
      // And if we need scrollbar
      scrollbar: {
        el: ".swiper-scrollbar",
      },
    });
    this.token = localStorage.token;
  },
  created() {
    this.suggest();
    this.GetUser();
  },
};
</script>

<style>
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
  justify-content: center;
}
.vier-sheet-head {
  position: fixed !important;
  height: 400px !important;
}

.swiper-slide {
  width: auto;
}

.pop {
  transform: scale(0.95);
  opacity: 0.9;
  transition: 0.4s;
}

.swiper-slide-active {
  transform: scale(1.1);
  transition: 0.4s;
}
.pop-active {
  transform: scale(1.1);
  transition: 0.4s;
}

.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 0.96rem;
  font-weight: 500;
  letter-spacing: -0.1px !important;
  line-height: 2rem;
  word-break: break-all;
  justify-content: center;
}
</style>
